<div class="login-background background-image">
  <div class="logo-container">
    <img [src]="imageSource" class="logo-class">
  </div>
  <div class="background-image background-packaging-image">
    <div class="login-container">
      <form [formGroup]="loginForm" data-automation-id="login-form" autocomplete="on">
        <div class="mat-elevation-z8">
          <mat-toolbar id="login-toolbar">
            <span data-automation-id="login-form-title">{{ 'login.title' | transloco }}</span>
            <button class="blue" type="button" mat-icon-button
              [matMenuTriggerFor]="menuLanguage">
              <mat-icon>language</mat-icon>
              <mat-menu #menuLanguage>
                <button *ngFor="let countryCode of countryCodes" mat-menu-item (click)="setLanguage(countryCode)"
                  id="language-{{countryCode}}">
                  <span class="flag-icon flag-icon-{{countryCode}} space-right"></span>
                  {{'language.'+ countryCode | transloco}}
                </button>
              </mat-menu>
            </button>
          </mat-toolbar>
          <mat-card>
            <mat-card-header>
              <div mat-card-avatar>
                <mat-icon class="material-icons md-48" id="user-icon">account_circle</mat-icon>
              </div>
              <mat-card-title>
                <strong>{{ 'login.signIn' | transloco }}</strong>
              </mat-card-title>
              <mat-card-subtitle>{{ 'login.subtitle' | transloco }}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <p class="username-field">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'login.fields.user' | transloco }}</mat-label>
                  <input matInput type="text" name="username" formControlName="login" data-automation-id="login"
                    required class="small-input" autocomplete="username">
                  <mat-icon matPrefix>person</mat-icon>
                </mat-form-field>
                <ng-container *ngIf="usernameEntered">
                  <button (click)="resetUserName()" mat-icon-button color="primary" type="button">
                    <mat-icon>edit</mat-icon>
                  </button>
                </ng-container>
              </p>
              <p *ngIf="showPasswordField">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'login.fields.password' | transloco }}</mat-label>
                  <input matInput type="password" name="password" formControlName="password"
                    data-automation-id="password" class="small-input">
                  <mat-icon matPrefix>lock</mat-icon>
                </mat-form-field>
              </p>
            </mat-card-content>
            <mat-card-actions *ngIf="!usernameEntered || showPasswordField" class="flex-row-space-around">
              <button *ngIf="!usernameEntered" class="login-button" mat-raised-button [disabled]="nextButtonDisabled" (click)="nextClicked()"
                color="primary">{{ "login.next" | transloco }}
                <div class="spinner-container" *ngIf="spinnerActive">
                  <mat-spinner diameter="24" color="accent"></mat-spinner>
                </div>
              </button>

              <button *ngIf="showPasswordField" class="login-button" mat-raised-button [disabled]="signInButtonDisabled" (click)="signIn()"
                color="primary">{{"login.signIn" | transloco}}
                <div class="spinner-container" *ngIf="spinnerActive">
                  <mat-spinner diameter="24" color="accent"></mat-spinner>
                </div>
              </button>
            </mat-card-actions>

            <div *ngIf="showPasswordField && externalLogins.length > 0" class="login-divider">
                <mat-divider></mat-divider>
                <span [ngClass]="isDarkTheme ? 'text-dark-theme': 'text-light-theme'">{{ 'login.or' | transloco }}</span>
                <mat-divider></mat-divider>
              </div>

            <div *ngFor="let externalLogin of externalLogins" class="flex-row-space-around" style="padding-bottom: 8px;">
              <button
                type="button"
                class="sso-login-button"
                matRipple
                (click)="signInExternal(externalLogin.providerName)"
                [ngClass]="isDarkTheme ? 'sso-login-button-dark': 'sso-login-button-light'">
                <span class="sso-inner-button">
                  <img *ngIf="externalLogin.providerName.toLowerCase().includes('microsoft')" [src]="imageSourceMicrosoftLogo" alt="Microsoft Sign-In Logo" class="microsoft-logo-image">
                  <span class="sso-login-text">
                    {{ 'login.signInWith' | transloco: {displayName: externalLogin.displayName} }}
                  </span>
                </span>
              </button>
            </div>

          </mat-card>
        </div>
      </form>
      <div class="logo-container">
        <img src="/assets/images/logo/partner_logo_white.svg" class="logo-class">
      </div>

      <div class="footer-text">
        <span class="mat-headline-6 text-dark-theme">{{ 'login.noAccount' | transloco }}
          <a href="https://prezero-international.com/leistungen/sustainable-packaging/sustainable-packaging-optimization-tool" target="_blank">{{ 'login.contactUs' | transloco }}</a>
        </span>
      </div>
    </div>
    <div>
      <app-version data-automation-id="app-version"></app-version>
    </div>
  </div>
</div>
